module.exports = __webpack_public_path__ + "img/Hand_31_05_06.de3c0267.png";